/**
 * Brings the element the URL's fragment names into view, centred, a moment
 * after the page paints (the Header calls it on mount and on every
 * hashchange). Returns the cancel for that pending scroll, or nothing when
 * there is nothing to do.
 *
 * - A fragment that is not valid percent-encoding ("#%") names no element:
 *   the page stays where it is (decodeURIComponent would throw, and this
 *   runs in the Header's mount effect, where a throw blanks the page).
 * - Smooth, unless the visitor asked for reduced motion: then it jumps.
 */
export default function scrollToAnchor() {
    if (typeof window === 'undefined' || !window.location.hash) return undefined;

    let id;
    try {
        id = decodeURIComponent(window.location.hash.substring(1));
    } catch {
        return undefined;
    }

    const timeout = setTimeout(() => {
        const element = document.getElementById(id);
        if (!element) return;
        const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
        element.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }, 200);

    return () => clearTimeout(timeout);
}
